import React from 'react';
import moment from 'moment';
import {PAST_REQUEST,UPCOMING_REQUEST} from './Main'
import './App.css';

const ExpandTray = ({timeZone, requestList, requestType, cancelCarRequest}) => {
    const currentTime = moment().tz(timeZone);
    requestList = requestList.filter((ele) => {
        const scheduleTime = moment(ele.schedule_time).tz(timeZone);
        if (requestType === UPCOMING_REQUEST && scheduleTime?.isSameOrAfter(currentTime)) {
            return ele;
        }
        if (requestType === PAST_REQUEST && scheduleTime?.isBefore(currentTime)) {
            return ele;
        }
    })
    requestList.sort((a, b) => moment.utc(a.schedule_time).valueOf() - moment.utc(b.schedule_time).valueOf());
  return (
    <div style={{display: 'flex', justifyContent: 'center'}}className={'collapse-container-open'}>
      <ul style={{marginTop: "10px", listStyleType: 'none', padding: 0 }}>
          {requestList.map(request => (
            <li style={{marginTop: "5px" }} key={request.id}>Schedule Time: {moment(request.schedule_time).format('MMM DD, YYYY, hh:mm A')} <button style={{marginLeft: '20px' }} onClick={(e) =>cancelCarRequest(e, request)}>Cancel</button></li>
          ))}
        </ul>
    </div>
  );
};

export default ExpandTray;